import { FC, ReactNode } from 'react'
import { FlexboxGrid, Popover, Whisper } from 'rsuite'
import { TypeAttributes } from 'rsuite/esm/@types/common'

import { getShortAvatarName } from '../../utils/util'
import AdminUserIcon from '../Icons/BuyerPortal/AdminUserIcon'
import UserIcon from '../Icons/BuyerPortal/UserIcon'
import DroppeUserIcon from '../Icons/DroppeUserIcon'

import styles from '../../styles/BuyerPortal/UserPopover.module.less'

interface UserPopoverProps {
  fullName: string
  isAdmin: boolean
  title?: string | ReactNode
  hover?: boolean
  sm?: boolean
  className?: string
  isSuperUser?: boolean
  placement?: TypeAttributes.Placement

}

const getStyles = (isAdmin: boolean, isSuperUser: boolean, sm: boolean) => {
  switch (true) {
    case isAdmin:
      return 'short-name-admin'

    case isSuperUser:
      return 'short-name-droppe-user'

    case sm:
      return 'short-name-sm'

    default:
      return 'short-name'
  }
}

const UserPopover: FC<UserPopoverProps> = ({
  fullName,
  title = '',
  sm = false,
  hover = false,
  isAdmin = false,
  isSuperUser = false,
  className = '',
  placement = 'bottom',
}) => (
  <Whisper
    trigger="hover"
    placement={placement}
    open={isAdmin || hover ? undefined : false}
    speaker={<Popover className={styles['remove-popover']}>{title}</Popover>}
  >
    <FlexboxGrid.Item className={`${styles[getStyles(isAdmin, isSuperUser, sm)]} ${className}`}>
      {isAdmin && <AdminUserIcon />}
      {isSuperUser && <DroppeUserIcon />}
      {!(isSuperUser || isAdmin) && <UserIcon />}
      <span>{getShortAvatarName(fullName)}</span>
    </FlexboxGrid.Item>
  </Whisper>
)
export default UserPopover
